// extracted by mini-css-extract-plugin
module.exports = {"container":"AuditLogs_container__coFYw","cardWrapper":"AuditLogs_cardWrapper__2f8-k","card":"AuditLogs_card__2FOo4","dropdownWrapper":"AuditLogs_dropdownWrapper__2qpJ9"};